module.exports = __webpack_public_path__ + "img/vol06_character_name1.3cb6a642.png";